module.exports = __webpack_public_path__ + "static/img/14000532.b89da04c.png";